        // When the window has finished loading create our google map below

        window.initMap = function() {
          var location = {lat: -31.414192, lng: -64.181512};
          var map = new window.google.maps.Map(
              document.getElementById('map'), {zoom: 17, center: location});
          var marker = new window.google.maps.Marker({position: location, map: map});
        }

        //window.google.maps.event.addDomListener(window, 'load', initMap);
